import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import MessageProvider from "./components/MessageProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import './index.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <MessageProvider>
      <App />
    </MessageProvider>
  </ErrorBoundary>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js');
  });
}